import React from 'react';
import { IncidentAnalysis } from '../../types/incident';
import {
    getSeverityColor,
    getConfidenceColor,
    getBadgeColor,
    getSourceLabel
} from '../../utils/incidentUtils';

interface SummaryCardProps {
    analysis: IncidentAnalysis;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ analysis }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Analysis Summary</h3>
                <span className={`px-2 py-1 text-xs font-medium rounded-full ${getBadgeColor(analysis.is_from_history || false)}`}>
                    {getSourceLabel(analysis.is_from_history || false)}
                </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                {analysis.severity && (
                    <div className="text-center">
                        <div className={`inline-flex px-3 py-1 rounded-full text-sm font-medium border ${getSeverityColor(analysis.severity)}`}>
                            {analysis.severity.toUpperCase()}
                        </div>
                        <p className="text-xs text-gray-600 mt-1">Severity Level</p>
                    </div>
                )}
                {analysis.category && (
                    <div className="text-center">
                        <div className="text-2xl font-bold text-gray-900">{analysis.category}</div>
                        <p className="text-xs text-gray-600 mt-1">Category</p>
                    </div>
                )}
                {analysis.confidence_score && (
                    <div className="text-center">
                        <div className={`text-2xl font-bold ${getConfidenceColor(analysis.confidence_score)}`}>
                            {Math.round(analysis.confidence_score * 100)}%
                        </div>
                        <p className="text-xs text-gray-600 mt-1">Confidence</p>
                    </div>
                )}
            </div>

            {analysis.summary && (
                <p className="text-gray-700 text-sm leading-relaxed">{analysis.summary}</p>
            )}
        </div>
    );
};

export default SummaryCard;
